export const AFC_AUTH_FAILURE_RETRY_SEEN_KEY = 'afc_auth_failure_retry_seen';
